export const mainGoldFont = {
  dropShadow: true,
  dropShadowAngle: 1.6,
  dropShadowAlpha: 0.5,
  fill: [
    "#feff00",
    "#feffe8",
    "#feff00",
    "#ff7800"
  ],
  fillGradientStops: [
    0.2,
    0.5,
    0.7
  ],
  lineJoin: "round",
  miterLimit: 0,
  stroke: "#700000",
  strokeThickness: 5,
  whiteSpace: "normal"
};

export const YellowFontWithStroke = {
  fill: [
    "#ffff99",
    "#ffff33",
    "#ff9900",
    "#ff9900",
    "#ff6600"
  ],
  fillGradientStops: [
    "",
    0.4,
    0.69,
    0.8,
    0.9
  ],
  lineJoin: "round",
  stroke: "#8a0300",
  strokeThickness: 5
};

export const freespinsPopupsFont = {
  dropShadow: true,
  dropShadowAlpha: 0.3,
  dropShadowAngle: 1.6,
  dropShadowBlur: 4,
  dropShadowDistance: 4,
  fill: [
    "#feff26",
    "#ffffeb",
    "#feff00",
    "#fd8002",
    "#feff00",
    "#feff00"
  ],
  fillGradientStops: [
    0.2,
    0.5,
    0.65,
    0.75,
    0.8
  ],
  fontFamily: 'UbuntuBold',
  lineJoin: "round",
  miterLimit: 0,
  stroke: "#ff4029",
  strokeThickness: 5,
  whiteSpace: "normal"
};

export const jackpotStrokes = {
  0: { stroke: '#cc3300', strokeThickness: 5 },
  1: { stroke: '#990000', strokeThickness: 5 },
  2: { stroke: '#336600', strokeThickness: 5 },
};

export const amountYellowFont = {
  fill: [
    "#ffff99",
    "#ffff33",
    "#ff9900",
    "#ff9900",
    "#ff6600"
  ],
  fillGradientStops: [
    0.3,
    0.4,
    0.69,
    0.8,
    0.9
  ],
  lineJoin: "round",
  stroke: "#8a0300",
  strokeThickness: 5
}

export const amountYellowFontWithoutStroke = {
  ...amountYellowFont,
  stroke: null,
}
